import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "@xo-union/tk-css-grid/lib/styles.css";
const TopLevelContainer = _ref => {
  let {
    children,
    classes: classesProp,
    as: ComponentToRender,
    ...props
  } = _ref;
  const classes = useClasses(styles, classesProp);
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    className: classes['top-level-container']
  }, props), children);
};
process.env.NODE_ENV !== "production" ? TopLevelContainer.propTypes = {
  children: PropTypes.node,
  /**
   * Class dependencies
   */
  classes: classesPropType(['top-level-container']),
  /**
   * Component to render
   */
  as: PropTypes.elementType
} : void 0;
TopLevelContainer.defaultProps = {
  as: 'div'
};
export default TopLevelContainer;